import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type HTMLAttributes, type ReactNode } from 'react';
import styles from './FormActions.module.scss';
export type FormActionsAlign = 'start' | 'center' | 'end';
export interface FormActionsProps extends HTMLAttributes<HTMLDivElement> {
  align?: FormActionsAlign;
  stretch?: boolean;
  children: ReactNode;
}
function FormActions(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      align: t1,
      stretch: t2,
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const align = t1 === undefined ? "start" : t1;
  const stretch = t2 === undefined ? true : t2;
  const t3 = styles[`helios-form-actions--align-${align}`];
  let t4;
  if ($[6] !== className || $[7] !== stretch || $[8] !== t3) {
    t4 = classNames(styles["helios-form-actions"], t3, {
      [styles["helios-form-actions--stretch"]]: stretch
    }, className);
    $[6] = className;
    $[7] = stretch;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== children || $[11] !== props || $[12] !== t4) {
    t5 = <div className={t4} {...props}>{children}</div>;
    $[10] = children;
    $[11] = props;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export default FormActions;